/**
 * Relationship Direction
 */
export enum RelationshipDirection {
  /**
   * Caregiver to Senior
   */
  CaregiverToSenior = 'caregiver-to-senior',

  /**
   * Senior to Senior
   */
  SeniorToSenior = 'senior-to-senior',
}
